export function getType(media) {
  if (media.id.includes('_')) {
    return 'posts';
  } else if (media.permalink && media.permalink.includes('instagram')) {
    if (media.permalink.includes('stories')) return 'stories';
    return 'posts';
  }

  return 'ads';
}